import React from 'react';

import { Group, Text } from '@mantine/core';

// TODO: перенести стили в css
const getRowStyles = () => ({
    flexWrap: 'nowrap',
});

export default function useColPocketTitleSchema({ accessor }) {
    const colPocketTitleSchema = {
        accessor,
        title: 'Заголовок',
        render: ({ row, currentData }) => (
            <Group
                spacing="xs"
                sx={getRowStyles}
            >
                <Text lineClamp={1}>
                    {row.name || currentData}
                </Text>
            </Group>
        ),
    };

    return colPocketTitleSchema;
}
